import { lazy } from 'react';

const MultiAskAI = lazy(() => import('./MultiAskAI'));

export default MultiAskAI;
